// extracted by mini-css-extract-plugin
module.exports = {"container":"ClientSection_container__Hw47u","initialName":"ClientSection_initialName___iL-L","clientName":"ClientSection_clientName__3JoWp","error":"ClientSection_error__3GhNy"};